// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4814) return "static/chunks/4814-cc90fa64e56a7025.js";
	if (chunkId === 8081) return "static/chunks/8081-316b05ff1212a10c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"4106":"b9633c63","9486":"cdcd3b9e"}[chunkId] || chunkId) + "." + {"4052":"a66b12b78675f94e","4106":"60420a8ad16cdc9a","6151":"cf1d641c1c36eaea","8532":"cf1d641c1c36eaea","8950":"eef002c9f6cdf536","9486":"45df373f2b3627e0"}[chunkId] + ".js";
};